import { Component, HostListener, OnInit } from '@angular/core';
import { Globals } from './common/globals';
import { CommonService } from './common/services/common.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'chc-frontend';

  private lastW = 0;
  private lastH = 0;
  private resizeLock = false;

  constructor(
    protected globals: Globals,
    private router: Router,
    protected commonService: CommonService
  ) {}

  ngOnInit() {
    this.lastW = window.innerWidth;
    this.lastH = window.innerHeight;
  }

  @HostListener('window:resize')
  onResize() {
    const w = window.innerWidth;
    const h = window.innerHeight;
    if (!this.resizeLock && w !== this.lastW && h !== this.lastH) {
      document.querySelectorAll('.k-animation-container').forEach((el) => el.remove());
      const firstField = document.querySelector<HTMLElement>('.default_lbl');
      if (firstField) {
        firstField.click();
      }
      this.lastW = w;
      this.lastH = h;
      this.resizeLock = true;
      setTimeout(() => (this.resizeLock = false), 100);
    }
  }

  isCredentialRegistryPage(): boolean {
    return this.globals.currentLinkArr[1] === 'credential-registry';
  }

  isSignUpTandCPage(): boolean {
    return this.globals.currentLinkArr[2] === 'signup-terms-conditions';
  }
}
